module.exports = __webpack_public_path__ + "static/media/07_CORTININHA_SEM_BOJO_LISO_03.1345ef8b.jpg";